import React, { useState } from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { useToast } from "../hooks/use-toast";

const CTA = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const { toast } = useToast();

  const onSubmit = (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      toast({
        title: "Please enter a valid email",
        description: "We use it only to set up your Good Fruit Hub.",
      });
      return;
    }
    // mock save to localStorage
    const list = JSON.parse(localStorage.getItem("good_fruit_waitlist") || "[]");
    list.push({ email, at: new Date().toISOString() });
    localStorage.setItem("good_fruit_waitlist", JSON.stringify(list));
    setSubmitted(true);
    toast({
      title: "You're in — welcome.",
      description: "Your Good Fruit Hub setup link is on its way.",
    });
  };

  return (
    <section id="cta" className="bg-white py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <div className="relative rounded-3xl bg-black text-white p-10 md:p-16 overflow-hidden">
          <div
            className="absolute -top-32 -left-32 w-[420px] h-[420px] rounded-full blur-3xl opacity-30"
            style={{
              background:
                "radial-gradient(circle, #14b8a6 0%, transparent 70%)",
            }}
          />
          <div
            className="absolute -bottom-32 -right-32 w-[420px] h-[420px] rounded-full blur-3xl opacity-25"
            style={{
              background:
                "radial-gradient(circle, #2dd4bf 0%, transparent 70%)",
            }}
          />
          <div className="relative text-center">
            <div className="text-xs uppercase tracking-[0.2em] text-teal-300 font-medium">
              Ready when you are
            </div>
            <h2 className="mt-4 text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.05]">
              Plant your Hub.{" "}
              <em className="text-teal-300 font-serif font-normal">
                Watch it bear fruit.
              </em>
            </h2>
            <p className="mt-5 text-white/70 max-w-2xl mx-auto text-lg">
              When people feel genuinely connected — seen, heard, and part of
              something — they flourish. And when your people flourish, so
              does everything you&apos;re building.
            </p>

            {!submitted ? (
              <form
                onSubmit={onSubmit}
                className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3 max-w-xl mx-auto"
              >
                <Input
                  type="email"
                  placeholder="Enter your church email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="h-12 bg-white/10 border-white/20 text-white placeholder:text-white/50 focus-visible:ring-teal-400 focus-visible:border-teal-400"
                />
                <Button
                  type="submit"
                  className="bg-teal-400 hover:bg-teal-300 text-black font-semibold h-12 px-6 w-full sm:w-auto"
                >
                  Start building free
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </form>
            ) : (
              <div className="mt-10 inline-flex items-center gap-3 bg-teal-400/15 border border-teal-400/30 text-teal-200 rounded-full px-5 py-3">
                <CheckCircle2 className="w-5 h-5" />
                <span>Your Good Fruit Hub setup link is on its way.</span>
              </div>
            )}

            <p className="mt-5 text-xs text-white/50">
              Free to start · No credit card required · Your Hub, live in
              minutes.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
